import { render } from "./DATA.vue?vue&type=template&id=e69fd822"
import script from "./DATA.vue?vue&type=script&lang=js"
export * from "./DATA.vue?vue&type=script&lang=js"
script.render = render

export default script